import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=8ded3268&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=ts"
export * from "./UserForm.vue?vue&type=script&lang=ts"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=8ded3268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ded3268",
  null
  
)

export default component.exports